export default {
  apiKey: 'AIzaSyBD28W1cWyDk7FunT3yhOo9bvCLHecbZ40',
  authDomain: 'p3-banking.firebaseapp.com',
  databaseURL: 'https://p3-banking.firebaseio.com',
  projectId: 'p3-banking',
  storageBucket: 'p3-banking.appspot.com',
  messagingSenderId: '54598259',
  appId: '1:54598259:web:b564e94f135f074a162806',
};
